import { SVGProps } from "react";

// Progress 100%. Filled ring with checkmark, used by goal progress chips
// when a goal is shipped/closed.
const Progress100 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM13.207 4.29297C12.8165 3.90244 12.1835 3.90244 11.793 4.29297L6.5 9.58594L4.20703 7.29297C3.81651 6.90244 3.18349 6.90244 2.79297 7.29297C2.40244 7.68349 2.40244 8.31651 2.79297 8.70703L5.79297 11.707C6.18349 12.0976 6.81651 12.0976 7.20703 11.707L13.207 5.70703C13.5976 5.31651 13.5976 4.68349 13.207 4.29297Z"
    />
  </svg>
);

export default Progress100;
